// ─────────────────────────────────────────────────────────────────
// SWISO TECH PROCESS GUIDE — AUTH CONFIGURATION
// ─────────────────────────────────────────────────────────────────
//
// HOW TO CHANGE THE PASSWORD:
// ─────────────────────────────────────────────────────────────────
// Option A — Browser console:
//   async function hash(pw) {
//     const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(pw));
//     return [...new Uint8Array(buf)].map(x => x.toString(16).padStart(2,'0')).join('');
//   }
//   hash('YourNewPassword').then(console.log);
//
// Option B — Node.js terminal:
//   node -e "const c=require('crypto');console.log(c.createHash('sha256').update('YourNewPassword').digest('hex'))"
//
// Then replace PASSWORD_HASH below with the new hash.
// ─────────────────────────────────────────────────────────────────
//
// CURRENT PASSWORD: SwisoDev2025!
// (Share this with authorised employees only — change after first deployment)
// ─────────────────────────────────────────────────────────────────

export const AUTH_CONFIG = {
  // SHA-256 hash of the access password
  // Current password: SwisoDev2025!
  PASSWORD_HASH: 'd81e94e4111ff18b0fe74c2a3c1edbb009638d22de318504b381e6cc4e01b415',

  // Session duration — auto-logout after this period of inactivity (milliseconds)
  // Default: 8 hours
  SESSION_DURATION_MS: 8 * 60 * 60 * 1000,

  // Lock out after this many consecutive failed attempts
  MAX_ATTEMPTS: 5,

  // Lockout duration after max failed attempts (milliseconds)
  // Default: 15 minutes
  LOCKOUT_MS: 15 * 60 * 1000,
};
